import { render, staticRenderFns } from "./PoiForm.vue?vue&type=template&id=20bc5423&"
import script from "./PoiForm.vue?vue&type=script&lang=js&"
export * from "./PoiForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports